// extracted by mini-css-extract-plugin
export default {"title":"entry-data-pemilik_title__GgTxb"};